import { apiNotificationsFetch } from '../index';
import { NotificationsBatchReadBody, ReadAllNotificationsResponse } from './types';

export const _notificationsBatchRead = (body: NotificationsBatchReadBody) => {
  return apiNotificationsFetch('/batch-read', {
    method: 'PUT',
    body,
  });
};

export const _notificationsRead = (id: string) => {
  return apiNotificationsFetch(`/${id}/read`, {
    method: 'PUT',
  });
};

export const _notificationsReadAll = () => {
  return apiNotificationsFetch<ReadAllNotificationsResponse>('/read-all', {
    method: 'PUT',
  });
};
